import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { ControlContainer } from '@angular/forms';

@Directive({
  selector: '[appCloseBanner]'
})
export class CloseBannerDirective implements OnInit {
  parentForm;
  @Input()
  public appCloseBanner!: string;

  @HostListener('close', ['$event']) onClose($event) {
    this.renderer.setStyle(
      this.el.nativeElement,
      'display',
      'none'
    );
  }

  constructor(public renderer: Renderer2,
    public el: ElementRef,
    private controlContainer: ControlContainer) {
  }

  ngOnInit() {
    this.parentForm = this.controlContainer.control;
    this.parentForm.controls[this.appCloseBanner]?.valueChanges.subscribe(() => {
      this.renderer.removeStyle(
        this.el.nativeElement,
        'display'
      );
    });
  }
}
